module.exports = __webpack_public_path__ + "img/94.58cda2de.jpg";